import React from "react";
import { Typography } from "@mui/material";

export const DynamicTypography = ({
  variant = "body1",
  fontSize,
  color,
  bold,
  margin,
  padding,
  align,
  style,
  sx,
  component: Component = Typography,
  ...props
}) => {
  return (
    <Component
      variant={variant}
      fontSize={fontSize}
      color={color}
      sx={{
        fontWeight: bold ? "bold" : "normal",
        margin,
        padding,
        textAlign: align,
        ...sx,
        ...style,
      }}
      {...props}
    />
  );
};
